const fr = {
  metaTitle: "SkillSynergy | Blog",
  metaDescription:
    "Des notes sur la programmation, l'IA et l'apprentissage du développement logiciel, par les formateurs de SkillSynergy.",
  navLabel: "Blog",
  eyebrow: "Écrits",
  title: "Notes de la salle de classe",
  lead: "Quelques textes sur la programmation, l'IA et ce qui vaut vraiment la peine d'être appris.",
  readTime: (minutes: number) => `${minutes} min de lecture`,
  backToBlog: "Revenir à tous les articles",
  publishedOn: "Publié le",
  englishOnlyNotice: "Cet article n'est disponible qu'en anglais.",
  readMore: "Lire l'article",
};

export default fr;
